import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiRouteConstants } from '../../../constants/api-routes';
import { CardOnFileResponse } from '../../../models/commerce/cards-on-file/card-on-file-response';
import { CreateCardOnFileRequest } from '../../../models/commerce/cards-on-file/create-card-on-file-request';
import { CreateCardOnFileResponse } from '../../../models/commerce/cards-on-file/create-card-on-file-response';
import { GetAllCardsOnFileResponse } from '../../../models/commerce/cards-on-file/get-all-cards-on-file-response';
import { GetEligibleCardsForOrderResponse } from '../../../models/commerce/cards-on-file/get-eligible-cards-for-order-response';
import { SaveCardOnFileRequest } from '../../../models/commerce/cards-on-file/save-card-on-file-request';

@Injectable({
    providedIn: 'root',
})
export class CreditCardService {
    private readonly creditCardApiRoute = ApiRouteConstants.CreditCard;

    constructor(private readonly http: HttpClient) {}

    create(
        userId: number,
        request: CreateCardOnFileRequest,
    ): Observable<CreateCardOnFileResponse> {
        return this.http.post<CreateCardOnFileResponse>(
            this.creditCardApiRoute.getRootUrl(userId),
            request,
        );
    }

    get(userId: number, cardOnFileId: number): Observable<CardOnFileResponse> {
        return this.http.get<CardOnFileResponse>(
            this.creditCardApiRoute.getByIdUrl(userId, cardOnFileId),
        );
    }

    update(
        userId: number,
        cardOnFileId: number,
        request: SaveCardOnFileRequest,
    ): Observable<void> {
        return this.http.post<void>(
            this.creditCardApiRoute.getByIdUrl(userId, cardOnFileId),
            request,
        );
    }

    delete(userId: number, cardOnFileId: number): Observable<void> {
        return this.http.delete<void>(
            this.creditCardApiRoute.getByIdUrl(userId, cardOnFileId),
        );
    }

    getAll(userId: number): Observable<GetAllCardsOnFileResponse> {
        return this.http.get<GetAllCardsOnFileResponse>(
            this.creditCardApiRoute.getRootUrl(userId),
        );
    }

    getAllForOrder(
        userId: number,
        orderId: number,
    ): Observable<GetEligibleCardsForOrderResponse> {
        return this.http.get<GetEligibleCardsForOrderResponse>(
            this.creditCardApiRoute.getEligibleCardsForOrderUrl(
                userId,
                orderId,
            ),
        );
    }
}
